import { FunctionComponent, HTMLAttributes } from "react";
import styles from "./profileGrid.module.css";

export const ProfileGrid: FunctionComponent<HTMLAttributes<HTMLDivElement>> = ({
  children,
}) => {
  return <div className={styles.profileGrid}>{children}</div>;
};
